import { Configuration, DefaultApi } from 'centerpiece-algorithm-client';

export const configuration = new Configuration({
  basePath: 'https://cxd98nj4xe.execute-api.eu-central-1.amazonaws.com',
});

export const api = new DefaultApi(configuration);
